module.exports = __webpack_public_path__ + "static/2-359fa67a7c24fadf260ee99a15f4ec00.png";